export default __webpack_public_path__ + "static/media/trans_breast.8ad4b803.png";